import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/weeklyship/sheet-import`;

// Warehouse-sheet auto-import: saved sheet per shop, last run, open problems.
const getStatus = () => axios.get(API_URL);

// spreadsheet = the Google Sheets link or ID; '' clears it (superuser).
const saveSheet = (shop, spreadsheet) => axios.put(`${API_URL}/sources`, { shop, spreadsheet });

// "Pull now" — starts in the background; poll getStatus until running is false (superuser).
const runNow = () => axios.post(`${API_URL}/run`);

// resolution: 'done' | 'dropped'
const resolveIssue = (id, resolution = 'done') => axios.post(`${API_URL}/issues/${id}/resolve`, { resolution });

const SheetImportService = { getStatus, saveSheet, runNow, resolveIssue };

export default SheetImportService;
